<template>
    <document-files-get
        :params="{ document: $route.params.document }"
        :page="page"
        :per-page="12"
        :archived="archived"
    >
        <div
            slot-scope="{
                data: files,
                meta,
                error,
                is_loading,
                has_loaded,
                get
            }"
            :class="!has_loaded || error ? '' : 'rounded bg-grey-bg shadow'"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="get"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <header class="flex items-center bg-white border-b rounded-t py-3 px-4 sm:px-6 md:py-3">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Files</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full text-grey fill-current"
                        />
                    </div>

                    <base-dropdown placement="bottom-end">
                        <button
                            slot="trigger"
                            slot-scope="{ is_open, toggle }"
                            :class="{ 'is-active': is_open }"
                            class="btn btn-with-icon"
                            type="button"
                            @click.prevent="toggle"
                        >
                            <div class="flex w-full h-full items-center">
                                <base-svg
                                    name="icon-funnel"
                                    class="w-6 h-6 md:mr-2"
                                />
                                <span class="hidden md:inline">Filter</span>
                            </div>
                        </button>
                        <div
                            slot="menu"
                            class="bg-grey-darker text-white shadow-lg rounded mt-3px p-3 w-64"
                        >
                            <label class="cursor-pointer flex items-center leading-none">
                                <input-checkbox
                                    v-model="archived"
                                    class="mr-3"
                                />
                                Archived
                            </label>
                        </div>
                    </base-dropdown>
                </header>

                <files-list :files="files" />

                <footer class="bg-grey-bg rounded-b pt-3 px-4 sm:px-6 text-sm text-grey-darker font-semibold">
                    <base-pagination
                        v-model="page"
                        :per-page="meta.per_page"
                        :from="meta.from"
                        :to="meta.to"
                        :last-page="meta.last_page"
                        :count="meta.count"
                        :total="meta.total"
                        :is-disabled="is_loading"
                    />
                </footer>
            </template>
        </div>
    </document-files-get>
</template>

<script>
    import DocumentFilesGet from '../../../../../components/document-files-get'
    import FilesList from '../../../../../components/files-list'
    import PaginationMixin from '../../../../../mixins/pagination'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            DocumentFilesGet,
            FilesList
        },
        data () {
            return {
                archived: false
            }
        }
    }
</script>
